import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "user_reports",
    object: "user_report",
    header: [
      { text: "Reportado", value: "reported_name" },
      { text: "Reportado por", value: "reporter_name" },
      { text: "Estado Conversación", value: "conversation_status" },
      { text: "Mensaje", value: "message_content" },
      { text: "Motivo", value: "report_reason" },
      { text: "Fecha", value: "created_at" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    options: {
      sortBy: ["created_at"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
